import { Component,  Input } from '@angular/core';
import { Program, Session, Setup } from 'globals/store/programs.data';
import { Wrapper } from '../../components/wrapper.component';
import { Dictionary } from '@ngrx/entity';
import { sessionMapReselector } from '../../store/reselectors/sessions.reselector';
import { SimpleSessionSelectorData, SimpleSessionSelectorDialogComponent } from '../../components/performers/session-selector.dialog.component';
import { getXYFromEventAndWidth } from '../../helpers/helpers';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { GreyWrapperComponent } from 'src/app/components/wrappers/grey-wrapper.component';
import { TitleIconComponent } from 'src/app/components/icon/title-icon.component';
import { SetupTimeComponent } from '../logistics/setup-time.component';
import { AssetsComponent } from '../assets/assets.component';
import { OnSessionsViewComponent } from '../logistics/on-sessions-view.component';
import { EditableNotesComponent } from '../program/editable-notes.component';
import { IdsToTagDataPipe } from 'src/app/services/pipes/idsToTagData.pipe';

@Component({
    selector: 'program-setup',
    templateUrl: './manage-program-setup.html',
    styleUrls: ['./manage-program-setup.scss'],
    standalone: true,
    imports: [JoiInputComponent, IdsToTagDataPipe, EditableNotesComponent, OnSessionsViewComponent, AssetsComponent, GreyWrapperComponent, TitleIconComponent, SetupTimeComponent ],
})
export class ProgramSetupComponent extends Wrapper<ProgramSetupComponent> {
  @Input() setup: Setup
  @Input() program: Program
  @Input() readOnly: boolean

  sessionMap: Dictionary<Session> = {}

  constructor() {
    super()
    this.selectProp(sessionMapReselector, null, 'sessionMap')
  }

  saveSetup() {
    this.programService.updateProgramSetup(this.program, this.setup)
  }

  saveAssetIds(ids: string[]) {
    const oldIds = this.setup.assetIds || []
    this.setup.assetIds = [...oldIds, ...ids]
    this.saveSetup()
  }

  removeSessionId(idToRemove: string) {
    this.setup.sessionIds = this.setup.sessionIds.filter(id => id !== idToRemove)
    this.saveSetup()
  }

  async editSessionIds(event) {
    const data: SimpleSessionSelectorData = { ...getXYFromEventAndWidth(event, 300), program: this.program, sessionIds: this.setup.sessionIds || [] }
    console.log({ data })
    const sessionIds: string[] = await this.openDialogGetResult(SimpleSessionSelectorDialogComponent, { width: '300px', data, backdropClass: 'clear', disableClose: true })
    console.log({ sessionIds })
    if (sessionIds && jsonCopyObject(sessionIds) !== jsonCopyObject(this.setup.sessionIds)) {
      this.setup.sessionIds = sessionIds
      this.saveSetup()
    }
  }

  removeAssetId(idToRemove: string) {
    this.setup.assetIds = this.setup.assetIds.filter(id => id !== idToRemove)
    this.saveSetup()
  }

}

